import Vue from 'vue'
import Vuex from 'vuex'
import projects from './modules/projects'
import photo from './modules/photo'
import photoDocumentation from './modules/photoDocumentation'
import constructionDiary from './modules/constructionDiary'
import appSettings from './modules/appSettings'
import tasks from './modules/tasks'
import plans from './modules/plans'
import current from './modules/current'
import customers from './modules/customers'
import customer from './modules/customer'
import tickets from './modules/tickets'
Vue.use(Vuex)

// if live enable this function!!!
// console.log('Live - NO LOG!')
// window.console.log = function() {
//   // overwritten
// };

export default new Vuex.Store({
  modules: {
    projects,
    photo,
    photoDocumentation,
    constructionDiary,
    appSettings,
    tasks,
    plans,
    current,
    customers,
    customer,
    tickets
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js